import { z } from 'zod';

export const createOverrideSchema = z.object({
  siteOverride: z.object({
    id: z.string(),
  }),
});
